export default __webpack_public_path__ + "static/media/fasad6.1c8a128c.jpeg";